import Debug from '../helpers/debug.js';
import { baseApiBuilder } from '../helpers/baseBuilder.js';
import { snapshots } from './snapshots/index.js';

const debug = Debug('commands:snapshots');

const command = 'snapshots <action>';

const desc = 'Manage tenant snapshots';

const builder = async function (yargs) {
  debug('builder', command, yargs);
  const base = await baseApiBuilder(yargs);
  return base.command(snapshots);
};

const handler = async function (argv) {
  debug('handler', command, argv);
};

export { command, desc, builder, handler };
